import { HIGHLIGHT_QUOTES } from "@/data/content";
import { Quote } from "lucide-react";

export default function HighlightQuotes() {
  if (!HIGHLIGHT_QUOTES || HIGHLIGHT_QUOTES.length === 0) return null;

  return (
    <section
      data-testid="highlight-quotes"
      className="relative islamic-pattern py-24 md:py-32"
    >
      <div className="relative max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="overline">In Their Own Words</span>
          <h2 className="mt-3 font-serif text-4xl md:text-5xl text-[color:var(--maqam-navy)] leading-[1.05] tracking-tight">
            Six lines that keep coming up.
          </h2>
          <p className="mt-5 text-[var(--maqam-muted)] leading-relaxed">
            Different pilgrims. Different trips. The same reflections — over and over again.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {HIGHLIGHT_QUOTES.map((q, i) => (
            <figure
              key={i}
              data-testid={`highlight-quote-${i}`}
              className="review-shadow review-shadow-hover rounded-2xl bg-white border border-[var(--maqam-border)] p-8 md:p-9 flex flex-col"
            >
              <Quote size={28} className="text-[color:var(--maqam-gold)]" />
              <blockquote className="mt-5 font-serif text-xl md:text-2xl text-[color:var(--maqam-navy)] leading-snug">
                “{q.text}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[var(--maqam-border)] text-xs uppercase tracking-[0.18em] text-[color:var(--maqam-gold-2)]">
                — {q.author}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
